'use client';

import type { ComponentProps } from 'react';
import logPrintMapButtonClicked from '@alltrails/amplitude/events/logPrintMapButtonClicked';
import Link from '@alltrails/denali/components/Link';
import usePrintModalExperiment from '@alltrails/experiments/hooks/usePrintModalExperiment';

const PrintMapsFooterLink = ({ children, ...linkProps }: ComponentProps<typeof Link>) => {
  const { sendExposure } = usePrintModalExperiment();

  return (
    <Link
      {...linkProps}
      onClick={() => {
        logPrintMapButtonClicked({ map_location: 'explore' });
        sendExposure();
      }}
    >
      {children}
    </Link>
  );
};

export default PrintMapsFooterLink;
